module.exports = __webpack_public_path__ + "static/media/eduprime-logo.91b626e3.png";